<div class="btn-group">
  <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
    Actions
  </button>
  <ul class="dropdown-menu">
    @for (linkUrlButton of linkUrlButtons; track linkUrlButton) {
      <li>
        @if (!linkUrlButton.hasEvent) {
          <a hasAnyRole [viewRoles]="linkUrlButton.viewRoles" class="dropdown-item" [routerLink]="linkUrlButton.linkUrl">{{ linkUrlButton.labelButton }}</a>
        }
        @if (linkUrlButton.hasEvent) {
          <button hasAnyRole [viewRoles]="linkUrlButton.viewRoles" class="dropdown-item text-danger" (click)="eventClick()">
            {{ linkUrlButton.labelButton }}
          </button>
        }
      </li>
    }
  </ul>
</div>
